import * as roseandpaul from './roseandpaul';
import * as mikeandcharlie from './mikeandcharlie';

export const COUPLES = {
    roseandpaul,
    mikeandcharlie
};